import { render } from "./CourseSectionsSelector.vue?vue&type=template&id=35e98ed0"
import script from "./CourseSectionsSelector.vue?vue&type=script&lang=js"
export * from "./CourseSectionsSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CourseSectionsSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35e98ed0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35e98ed0', __exports__)) {
    api.reload('35e98ed0', __exports__)
  }
  
  module.hot.accept("./CourseSectionsSelector.vue?vue&type=template&id=35e98ed0", () => {
    api.rerender('35e98ed0', render)
  })

}


export default __exports__